import { z } from "zod";

const DataResponseSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.nullable(z.string()),
    group: z.nullable(z.string()),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

const PaginationResponseSchema = z.object({
    current_page: z.number(),
    first_page_url: z.string(),
    from: z.number(),
    last_page: z.number(),
    last_page_url: z.string(),
    next_page: z.number(),
    next_page_url: z.nullable(z.string()),
    path: z.string(),
    per_page: z.number(),
    prev_page: z.number(),
    prev_page_url: z.nullable(z.string()),
    to: z.number(),
    total: z.number(),
});

export const PermissionsResponseSchema = z.object({
    code: z.number(),
    data: z.array(DataResponseSchema),
    message: z.string(),
    pagination: PaginationResponseSchema,
    success: z.boolean(),
});

export type PermissionsResponse = z.infer<typeof PermissionsResponseSchema>;
export type PermissionResponse = z.infer<typeof DataResponseSchema>;